import { render, staticRenderFns } from "./RestockContent.vue?vue&type=template&id=84051f64&scoped=true&"
import script from "./RestockContent.vue?vue&type=script&lang=ts&"
export * from "./RestockContent.vue?vue&type=script&lang=ts&"
import style0 from "./RestockContent.vue?vue&type=style&index=0&id=84051f64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84051f64",
  null
  
)

export default component.exports